import Vue from 'vue'
import '@mdi/font/css/materialdesignicons.css'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify); 
export default new Vuetify({ 
     icons: {
          iconfont: 'mdi',
     },
     theme: {
          themes: {
               light: {
                    rz: "#D2567C",
                    bl: "#3368C6",
                    gr: "#029F96",
                    mv: "#9C27B0",
               },  
          }
     },
 
});
